"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _urlUtils = require("../../common/utils/domain/urlUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  GrowthPlan = _require.GrowthPlan;
const formatGrowthPlan = (properties, {
  domains
} = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$porintId = properties.porintId,
    porintId = _properties$porintId === void 0 ? '' : _properties$porintId,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$authentic = properties.authenticationConfiguration,
    authenticationConfiguration = _properties$authentic === void 0 ? {} : _properties$authentic,
    _properties$productRe = properties.productResourceConfiguration,
    productResourceConfiguration = _properties$productRe === void 0 ? {} : _properties$productRe;
  const _authenticationConfig = authenticationConfiguration.title,
    title = _authenticationConfig === void 0 ? '' : _authenticationConfig,
    _authenticationConfig2 = authenticationConfiguration.list,
    list = _authenticationConfig2 === void 0 ? [] : _authenticationConfig2;
  const configuration = list.map((item, index) => {
    const formattedHref = formatUrlString(item.href || '');
    return _objectSpread(_objectSpread({}, item), {}, {
      href: formattedHref,
      extendProps: {
        'report-event': 'click_growthplan_href',
        'report-ext1': index,
        'report-ext2': item.txt,
        'report-ext3': formattedHref
      }
    });
  });
  const _productResourceConfi = productResourceConfiguration.videoData,
    videoData = _productResourceConfi === void 0 ? {} : _productResourceConfi,
    _productResourceConfi2 = productResourceConfiguration.txtData,
    txtData = _productResourceConfi2 === void 0 ? {} : _productResourceConfi2;
  const _ref = videoData || {},
    _ref$title = _ref.title,
    videoTitle = _ref$title === void 0 ? '' : _ref$title,
    _ref$configuration = _ref.configuration,
    videoDataList = _ref$configuration === void 0 ? [] : _ref$configuration;
  const _ref2 = txtData || {},
    _ref2$title = _ref2.title,
    textTitle = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$configuration = _ref2.configuration,
    txtDataList = _ref2$configuration === void 0 ? [] : _ref2$configuration;
  // 处理资源组件中视频教程部分数据解析
  const resultVideoList = videoDataList.map((videoItem, index) => {
    const value = _objectSpread({}, videoItem);
    value.img = value.type ? '' : value.img;
    value.type = value.type ? 'right' : 'center';
    value.extendProps = {
      'report-event': 'click_growthplan_video',
      'report-ext1': index,
      'report-ext2': value.description || '',
      'report-ext3': value.videoPlayUrl || ''
    };
    value.postMessageUrl = (0, _urlUtils.getVideoIframeUrl)();
    return value;
  });
  const resultTxtDataList = txtDataList.map((item, index) => {
    const _item$head = item.head,
      head = _item$head === void 0 ? '' : _item$head,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$description = item.description,
      description = _item$description === void 0 ? '' : _item$description;
    const formatContent = formatUrlInText(description, {
      reportEvent: 'click_growthplan_txt_richtext_href'
    });
    return {
      head,
      title,
      description: formatContent
    };
  });
  return {
    modTitle,
    porintId,
    color,
    authenticationConfiguration: {
      title,
      flexTitle: modTitle,
      list: configuration
    },
    productResourceConfiguration: {
      videoData: {
        title: videoTitle,
        configuration: resultVideoList
      },
      txtData: {
        title: textTitle,
        configuration: resultTxtDataList
      },
      type: 'cyan'
    }
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatGrowthPlan = formatGrowthPlan(data, {
        domains
      }),
      modTitle = _formatGrowthPlan.modTitle,
      porintId = _formatGrowthPlan.porintId,
      _formatGrowthPlan$col = _formatGrowthPlan.color,
      color = _formatGrowthPlan$col === void 0 ? '' : _formatGrowthPlan$col,
      _formatGrowthPlan$aut = _formatGrowthPlan.authenticationConfiguration,
      authenticationConfiguration = _formatGrowthPlan$aut === void 0 ? {} : _formatGrowthPlan$aut,
      _formatGrowthPlan$pro = _formatGrowthPlan.productResourceConfiguration,
      productResourceConfiguration = _formatGrowthPlan$pro === void 0 ? {} : _formatGrowthPlan$pro;
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_growthPlan', componentKey, modTitle])), /*#__PURE__*/React.createElement(GrowthPlan, {
      style: bgStyle,
      authenticationConfiguration: authenticationConfiguration,
      productResourceConfiguration: productResourceConfiguration
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}